module.exports = __webpack_public_path__ + "img/features_pic04.86d19360.png";